import { render } from "./GetAllCategories.vue?vue&type=template&id=02f92ed9&scoped=true"
import script from "./GetAllCategories.vue?vue&type=script&lang=js"
export * from "./GetAllCategories.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f92ed9"]])

export default __exports__